import CollapsibleHeading from "./CollapsibleHeading";

export default CollapsibleHeading;
